<template>
  <v-container>
    <v-card class="pa-4">
      <v-card-title class="text-h6">🔍 Buscar Pedidos</v-card-title>

      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="filtros.id"
            label="ID del Pedido"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="filtros.cliente"
            label="Nombre del Cliente"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="filtros.estado"
            :items="estados"
            label="Estado"
            clearable
          ></v-select>
        </v-col>
      </v-row>

      <v-btn color="primary" @click="buscarPedidos" :loading="cargando" class="mt-2">
        Buscar
      </v-btn>
    </v-card>

    <v-card class="mt-6" v-if="pedidos.length > 0">
      <v-card-title class="text-h6">📦 Resultados</v-card-title>

      <v-data-table
        :headers="headers"
        :items="pedidos"
        :items-per-page="10"
        class="elevation-1"
      ></v-data-table>
    </v-card>

    <v-alert
      type="info"
      class="mt-4"
      v-else-if="!cargando && yaBuscado"
    >
      No se encontraron pedidos con los filtros especificados.
    </v-alert>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'

const filtros = ref({
  id: '',
  cliente: '',
  estado: null,
})

const estados = ['Pendiente', 'Enviado', 'Entregado', 'Cancelado']

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Cliente', key: 'cliente' },
  { title: 'Fecha', key: 'fecha' },
  { title: 'Total', key: 'total' },
  { title: 'Estado', key: 'estado' },
]

const pedidos = ref([])
const cargando = ref(false)
const yaBuscado = ref(false)

const buscarPedidos = async () => {
  cargando.value = true
  yaBuscado.value = false

  try {
    await new Promise(resolve => setTimeout(resolve, 800))

    pedidos.value = [
      { id: 1001, cliente: 'Carlos Ruiz', fecha: '2025-07-01', total: '$800', estado: 'Pendiente' },
      { id: 1002, cliente: 'Ana Torres', fecha: '2025-07-10', total: '$450', estado: 'Entregado' },
    ].filter(p => {
      return (!filtros.value.id || p.id.toString().includes(filtros.value.id)) &&
             (!filtros.value.cliente || p.cliente.toLowerCase().includes(filtros.value.cliente.toLowerCase())) &&
             (!filtros.value.estado || p.estado === filtros.value.estado)
    })
  } catch (error) {
    console.error('Error al buscar pedidos:', error)
  } finally {
    cargando.value = false
    yaBuscado.value = true
  }
}
</script>
